module.exports = __webpack_public_path__ + "static/media/icon-list-black.9de58f01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-list-black.svg
// module id = ./src/assets/images/icon-list-black.svg
// module chunks = 6